module.exports = __webpack_public_path__ + "img/7940088.png";